
import React from 'react';
import { Toggle } from "@/components/ui/toggle";
import { Calculator, Sparkles } from "lucide-react";
import { FormData } from './types';
import { CrystalBallFormData } from '../crystal-ball/types';
import { useIsMobile } from '@/hooks/use-mobile';

interface ModeToggleProps {
  crystalBallMode: boolean;
  setCrystalBallMode: (value: boolean) => void;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  setCrystalBallData: React.Dispatch<React.SetStateAction<CrystalBallFormData>>;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
}

export const ModeToggle = ({
  crystalBallMode,
  setCrystalBallMode,
  setFormData,
  setCrystalBallData,
  setCurrentStep
}: ModeToggleProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex justify-center gap-2 mb-2 w-full">
      <Toggle
        pressed={!crystalBallMode}
        onPressedChange={() => {
          setCrystalBallMode(false);
          setFormData({
            salary: "",
            bonus: "",
            expenses: {
              internetPhone: "",
              techSoftware: "",
              workspaceOffice: "",
              professionalDev: "",
              healthcare: "",
              transportation: "",
            },
            timeOff: {
              vacation: "",
              sick: "",
              holidays: "",
            },
            productivityRate: "80"
          });
          setCurrentStep(1);
        }}
        className="data-[state=on]:bg-primary flex-1 max-w-[160px] px-2 sm:px-3"
      >
        <Calculator className="mr-1 sm:mr-2 h-4 w-4" />
        <span className="text-xs sm:text-sm whitespace-nowrap">
          {isMobile ? "Rate Calc" : "Calculate Your Rate"}
        </span>
      </Toggle>
      <Toggle
        pressed={crystalBallMode}
        onPressedChange={() => {
          setCrystalBallMode(true);
          setCrystalBallData({
            desiredHourlyRate: "",
            projectHours: "",
            complexityFactor: "1.0",
            billableHoursPerDay: "6",
            expenses: {
              internetPhone: "",
              techSoftware: "",
              workspaceOffice: "",
              professionalDev: "",
              healthcare: "",
              transportation: "",
            },
            timeOff: {
              vacation: "",
              sick: "",
              holidays: "",
            }
          });
          setCurrentStep(1);
        }}
        className="data-[state=on]:bg-primary flex-1 max-w-[160px] px-2 sm:px-3"
      >
        <Sparkles className="mr-1 sm:mr-2 h-4 w-4" />
        <span className="text-xs sm:text-sm whitespace-nowrap">
          {isMobile ? "Income Preview" : "Preview Income"}
        </span>
      </Toggle>
    </div>
  );
};
